import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { queryBuilder } from '@metromarkets/sdk';
import { QueryOptions, Product, MetaData } from '~shared/models';
import { DEFAULT_LIMIT } from '~app/modules/generic/constants';
import { BrandSearchResponse, BrandInfo } from '~app/modules/brand-plp/models';
import { API_PRODUCTS_LIST_ROUTE_V3 } from '~app/modules/catalog/constants';
import { API_BRAND_INFO_ROUTE_V3 } from '~app/modules/brand-plp/constants/api.constant';
import { SearchHttpService } from '~app/modules/generic/services/search-http.service';
import { deserialize } from 'serialize-ts';
import { CategoriesUtil } from '~app/modules/brand-plp/utils';

@Injectable({
  providedIn: 'root',
})
export class BrandPLPService {
  constructor(
    private http: HttpClient,
    private searchHttpService: SearchHttpService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  getProducts(queryOptions: QueryOptions = {}): Observable<BrandSearchResponse> {
    const params = this.getProductsAPIHTTPParams(queryOptions);
    return this.searchHttpService.getPaginatedProducts(API_PRODUCTS_LIST_ROUTE_V3(), params, 'angular_maco_brand_page').pipe(
      map((svcResponse: { correction: string; totalCount: number; items: Product[]; meta: MetaData }) => {
        return {
          correction: svcResponse.correction,
          products: {
            totalCount: svcResponse.totalCount,
            items: svcResponse.items.map((item) => Product.map(item)),
          },
          metaData: svcResponse.meta && deserialize(svcResponse.meta, MetaData),
        };
      })
    );
  }

  getBrandInfo(brandSlug: string): Observable<BrandInfo> {
    return this.http
      .get<BrandInfo>(
        `${API_BRAND_INFO_ROUTE_V3()}/${brandSlug}`,
        {
          headers: {
            'x-source': 'angular_maco_brand_search'
          }
        }
      )
      .pipe(
        map((data: BrandInfo) => {
          return { 
            ...data,
            categories: CategoriesUtil.getCategoryArray(data.categories),
          };
        })
      );
  }

  getBrandSlugById(brandId: string): Observable<string> {
    return this.http
      .get<BrandInfo>(
        `${API_BRAND_INFO_ROUTE_V3()}/${brandId}`,
        {
          headers: {
            'x-source': 'angular_maco_brand_search'
          }
        }
      )
      .pipe(map((brandInfo: BrandInfo) => brandInfo.slug));
  }

  private getProductsAPIHTTPParams(queryOptions: QueryOptions = {}): HttpParams {
    const { offset = 0, limit = DEFAULT_LIMIT, ...restQuery } = queryOptions;

    return queryBuilder.toParams({
      offset,
      limit,
      ...restQuery,
      ...{ useRecommendedProductsParser: '1' },
      ...{ useCharacteristics: '1' },
    }) as HttpParams;
  }
}
